<template lang="pug">
    div
        prism-editor(
            class="my-editor height-400"
            :highlight="highlighter"
            :line-numbers="true"
            :value="value"
            @input="updateParent"
        )
</template>

<script>
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere

import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-markup";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css"; // import syntax highlighting styles

export default {
    props: ["formItem", "formData", "value"],
    components: {
        PrismEditor
    },
    data() {
        return {};
    },
    methods: {
        highlighter(code) {
            let language = this.formItem.codeEditorLanguage || 'markup'
            return highlight(code, languages[language], language);
        },
        updateParent(value) {
            this.$emit("input", value);
            if (this.formItem && typeof this.formItem.watchField === 'function') {
                this.formItem.watchField(value, this.formData);
            }
        }
    }
};
</script>

<style>
.my-editor {
    background: #2d2d2d;
    color: #ccc;
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    padding: 5px;
}

.prism-editor__textarea:focus {
    outline: none;
}

.height-400 {
    height: 400px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/CodeEditor.vue